import { newInvoke } from '../../QTBridge';
import { call } from '@popo-bridge/web';
import { ToolTye } from '@/components/Note/utils';
import { Platform } from '@/utils/platform';
import { webEventEmitter } from '../../eventEmitter';

export interface ToolsState {
  toolType: ToolTye;
  enabled: boolean;
}
export interface toolsStateChangedParams {
  toolsState: ToolsState[];
}

/**
 * 工具栏状态发生变化 传回一个数组，数组内标识工具类型 ID, 与可用状态
 * @param params
 */
export const toolsStateChanged = async (params: toolsStateChangedParams) => {
  if (Platform.isPOPO) {
    if (Platform.isPC) {
      await newInvoke({
        methodName: 'toolsStateChanged',
        params: params,
      });
    } else {
      await call('toolsStateChanged', params);
    }
  } else {
    webEventEmitter.emit('toolsStateChanged', params);
  }
};
